import React,{useState,useEffect} from 'react';
import { useHistory } from "react-router-dom";
import firebase from 'firebase';
import { db } from './firebase/firebase';
const Dashboard=({user})=>{
    const history=useHistory();
    var detailObj={
        Name:"",
        email:''
    }

    var unSub=()=>{};
     var unSub2=()=>{};
    const [resourceData, setResourceData] = useState([])
    const [detail, setdetail] = useState(detailObj)
    const [Resource, setResource]  = useState('');
    const [Location, setLocation]  = useState('');
    const [Number, setNumber]  = useState('');
    // const [deleteData, setdeleteData] = useState("")

    useEffect(() => {
      if (user) {
        getUserData();
        getData();
      } else {
        history.push("/login")
      }
    
      return ()=>{
        unSub();
        unSub2();
      };
    },[])
  

    const  getUserData=()=>{
      console.log("getUserData");
       unSub2= db.collection("user").doc(user.uid)
      .onSnapshot((doc) => {
          setdetail({
              Name:doc.data().name,
              email:doc.data().email,
          })
      });
    }
    
    const getData = ()=>{
      console.log("getData");
       unSub= db.collection("resource").where("userid", '==', user.uid).onSnapshot(function (querySnapshot) {
      console.log("FB data", querySnapshot.docs.map(doc => doc.data()))
        setResourceData(
              querySnapshot.docs.map((doc) =>({
                  id:doc.id,
                  name: doc.data().name,
                  Location: doc.data().location,
                  Number: doc.data().phoneNumber,
                  Resource: doc.data().Resource
              }))
          );
           console.log("getData");
      })
  }

    const addData= (e)=>{
        e.preventDefault()
        db.collection("resource").add({
            userid:user.uid,
            name: detail.Name,
            location: Location,
            Resource: Resource,
            phoneNumber: Number,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });

        setResource("");
        setLocation("");
        setNumber("");
    }

    // Delete Data
    var deleteData=(value)=>{
      console.log(value);
      db.collection("resource").doc(value).delete();
      console.log("Data Deleted");
    }


        return (
            <div>
            {
        
            user?
            <>
            <div className="container d-flex justify-content-center">
                <div className="container dash-cont mt-3 p-5">
                <div>
                    <p className="mb-1">DashBoard</p>
                    <h4 className="text-white">Thank You For Helping</h4>
                    <h4 className="text-white">{detail.Name}</h4>
                    <h4 className=" text-white">{detail.email}</h4>
            </div>
            </div>
                
            </div>
            <div className="container ">
  
  <div className="container dash-cont3 cont-2x mt-3 p-5">
  <table className="table table-sm table-sticky-header my-4 mx-auto" id="myTable">
  <thead className="thead text-center">
    <tr>
  
    <th scope="col">Resource</th>
      <th scope="col">Name</th>
      <th scope="col">Address</th>
      <th scope="col">Phone</th>
      <th scope="col">Delete</th>
    </tr>
  </thead>
  <tbody className="bg-light text-center">
  {resourceData.map((data,index) =>{
    return (
      <>
     <tr key={data.id} id={data.id}>
        <td>{data.Resource}</td>
        <td>{data.name}</td>
        <td>{data.Location}</td>
        <td>{data.Number}</td>
        <td onClick={()=>deleteData(data.id)} style={{cursor:"pointer",fontWeight:"800"}}>Delete</td>
      </tr>

      </>
    )
  })} 
  </tbody>
</table>
</div>
  
  <div className="container dash-cont3 cont-2x mt-3 p-5">
<form >
  <div className="form-group">
<label htmlFor="exampleInputPassword1" style={{color:"white"}}>Your Number</label>
<input type="text" className="form-control" id="exampleInputPassword1" placeholder="You Contact Please" value={Number} onChange={(e) => {setNumber(e.target.value); console.log(e.target.value)}} />
</div>

  <div className="form-group">
<label htmlFor="exampleInputPassword3" style={{color:"white"}}>Your Location</label>
<input type="text" className="form-control" id="exampleInputPassword3" placeholder="You Contact Please"  value={Location} onChange={(e) => {setLocation(e.target.value); console.log(e.target.value)}} />
</div>
  <div className="form-group">
       
<label htmlFor="exampleInputPassword2" style={{color:"white"}}>Resource</label>
<input type="text" className="form-control" id="exampleInputPassword2" placeholder="Resource You Want To Share" value={Resource} onChange={(e) => {setResource(e.target.value); console.log(e.target.value)}} />
<small id="emailHelp" className="form-text text-white">Please Write Below Resources In Resource Box</small>
  <small id="emailHelp" className="form-text text-white">1. Plasma</small>       
  <small id="emailHelp" className="form-text text-white">2. Oxygen</small>       
  <small id="emailHelp" className="form-text text-white">3. Blood : A+/A-,B+/B-,O+/O-,AB+/AB-</small> 
</div>
<button type="submit" className="btn btn-primary" onClick={addData}>Add</button>
  </form> 
</div>
  </div>
            </>
            :
            history.push("/login")   
        } 
        </div> 
        ); 
  
      return 

}

export default Dashboard;